module.exports = Studio;


/*****************
 ** WEBPACK FOOTER
 ** external "Studio"
 ** module id = 2
 ** module chunks = 0
 **/